import { DesignTokens } from '../brands';
import sharedDsTokens from '../default/ds-tokens';

const dsTokens: DesignTokens = {
  ...sharedDsTokens,
  colors: {
    ...sharedDsTokens.colors,
    'brand-1': '#011E38',
    'brand-2': '#264FEC',
    'brand-3': '#264FEC',
    'dark-dark': '#000000',
    'dark-light': '#000000',
    actionNavigationStandardStatic: '#264FEC',
    actionNavigationStandardHighlight: '#264FEC',
    actionNavigationStandardDisabled: 'rgba(0, 0, 0, 0.16)',
    actionNavigationAltHighlight: '#264FEC',
    actionNavigationAltDisabled: 'rgba(255, 255, 255, 0.24)',
    actionConversionStatic: '#264FEC',
    actionConversionHighlight: '#304873',
    actionConversionDisabled: 'rgba(255, 255, 255, 0.24)',
  },
  fonts: {
    primary:
      "IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
    secondary:
      "IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol'",
  },
};

export default dsTokens;
